exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".buy_sell_table .badge{padding:5px 16px;width:80px;height:20px;text-align:center;padding:5px 10px;color:#ffffff}.buy_sell_table .bdg_blue{background-color:#7cb5ec}.buy_sell_table .bdg_orange{background-color:#fa871b}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/dist/cjs.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/common/buySellTable/buySellTable.style.scss
// module id = 618
// module chunks = 0